module.exports = __webpack_public_path__ + "img/emotion.7edcdd57.svg";